import { initializeStore as F } from "@seamless/store";
import { initializeLogger as be } from "@seamless/logger";
import { identifyTenant as Ne } from "@b2x/std/helpers.mjs";
import { getTranslation as Re } from "@owc/aem-translations-util";
/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */
/*! B2X@SHARED 2.133.0-alpha.0.2705955 */
const x = {
  AEM_CONNECTION_NAME: "OWC_AEM_ENV",
  REGISTRY_CONNECTION_NAME: "OWC_COMPONENT_REGISTRY",
  TRACKING_CONNECTION_NAME: "OWC_TRACKING_MANAGER",
  AUTH_CONNECTION_NAME: "B2XCORE_AUTHENTICATION",
  PROFILE_CONNECTION_NAME: "B2XCORE_PROFILE"
}, _t = "https://distributions.crowdin.net", Ie = "https://i18n.oneweb.mercedes-benz.com/projects";
async function Ce(e, t = 6e4) {
  const r = F();
  return await te(e, t) ? r.getConnectionDispatchers(e) : Promise.resolve({});
}
async function te(e, t = 1) {
  return F().getConnectionDispatchers(e, t).then(() => !0).catch(() => !1);
}
async function $t(e) {
  const t = F();
  return await te(
    x.REGISTRY_CONNECTION_NAME
  ) ? new Promise((n) => {
    t.once(x.REGISTRY_CONNECTION_NAME, (o) => {
      const a = Object.values(o.components);
      n(e ? e(a) : a);
    });
  }) : Promise.resolve([]);
}
function Se() {
  return Le(x.AEM_CONNECTION_NAME);
}
async function Le(e) {
  const t = F();
  return await te(e, 5) ? new Promise((n) => {
    t.once(e, (o) => {
      n(o);
    });
  }) : Promise.resolve({});
}
const Pe = "2.133.0-alpha.0.2705955", _e = "3.7.2025, 13:06:11";
function Mt(e) {
  try {
    JSON.parse(e);
  } catch {
    return !1;
  }
  return !0;
}
function $e() {
  return typeof window < "u";
}
function Dt() {
  return $e() && location.hostname.includes("localhost");
}
function Me(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function kt(e) {
  if (typeof e == "object" && e !== null) {
    if (typeof Object.getPrototypeOf == "function") {
      const t = Object.getPrototypeOf(e);
      return t === Object.prototype || t === null;
    }
    return Me(e);
  }
  return !1;
}
async function De(e) {
  try {
    return { data: await e, error: null };
  } catch (t) {
    return { data: null, error: t };
  }
}
function X(e, t = /* @__PURE__ */ new WeakSet()) {
  if (t.has(e))
    return e;
  t.add(e), Object.freeze(e);
  for (const r of Object.keys(e)) {
    const n = e[r];
    ke(n) && !Object.isFrozen(n) && X(n, t);
  }
  return e;
}
function ke(e) {
  return typeof e == "object" && e !== null;
}
function Oe(e, t, r = /* @__PURE__ */ new WeakMap()) {
  return Array.isArray(e) && Array.isArray(t) ? Ue(e, t) : Array.isArray(e) && P(t) ? je(e, t) : P(e) && Array.isArray(t) ? Ke(e, t) : P(e) && P(t) ? me(e, t, r) : P(t) ? t : P(e) ? e : t;
}
function P(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Ue(e, t) {
  return [...e, ...t];
}
function je(e, t) {
  const r = [...e];
  for (const n of Reflect.ownKeys(t))
    r[n] = t[n];
  return r;
}
function Ke(e, t) {
  const r = { ...e };
  for (let n = 0; n < t.length; n++)
    r[n] = t[n];
  return r;
}
function me(e, t, r) {
  if (r.has(t))
    return r.get(t);
  const n = { ...e };
  r.set(t, n);
  for (const o of Reflect.ownKeys(t)) {
    const a = t[o], s = e[o];
    Array.isArray(s) && Array.isArray(a) ? n[o] = Oe(s, a, r) : P(s) && P(a) ? n[o] = me(s, a, r) : n[o] = a;
  }
  return n;
}
function K(e) {
  const t = structuredClone(e);
  function r(i, u) {
    for (const l of Reflect.ownKeys(i))
      typeof l == "symbol" && (u[l] = K(i[l]));
  }
  function n(i, u, l) {
    for (let f = 0; f < i.length; f++)
      c(i[f], u[f], l);
  }
  function o(i, u, l) {
    for (const [f, S] of i)
      c(S, u.get(f), l);
  }
  function a(i, u, l) {
    for (const f of i)
      for (const S of u)
        typeof f == "object" && typeof S == "object" && f !== null && S !== null && c(f, S, l);
  }
  function s(i, u, l) {
    for (const f of Reflect.ownKeys(i))
      (typeof f == "string" || typeof f == "symbol") && c(i[f], u[f], l);
  }
  function c(i, u, l = /* @__PURE__ */ new WeakMap()) {
    if (!(!i || typeof i != "object" || !u || typeof u != "object") && !l.has(i)) {
      if (l.set(i, u), r(i, u), Array.isArray(i)) {
        n(i, u, l);
        return;
      }
      if (i instanceof Map && u instanceof Map) {
        o(i, u, l);
        return;
      }
      if (i instanceof Set && u instanceof Set) {
        a(i, u, l);
        return;
      }
      s(i, u, l);
    }
  }
  return c(e, t), t;
}
function B(e, t, r = /* @__PURE__ */ new WeakMap()) {
  return Object.is(e, t) ? !0 : typeof e != typeof t || typeof e != "object" ? !1 : e === null || t === null ? e === t : e instanceof Map != t instanceof Map || e instanceof Set != t instanceof Set || Array.isArray(e) !== Array.isArray(t) || e instanceof Date != t instanceof Date ? !1 : e instanceof Date ? e.getTime() === t.getTime() : e instanceof Map ? Be(e, t, r) : e instanceof Set ? xe(e, t, r) : Array.isArray(e) ? Ge(e, t, r) : ze(e, t, r);
}
function Be(e, t, r) {
  if (e.size !== t.size)
    return !1;
  if (r.has(e))
    return r.get(e) === t;
  r.set(e, t);
  const n = e.entries(), o = t.entries();
  let a = n.next(), s = o.next();
  for (; !(a.done || s.done); ) {
    const [c, i] = a.value, [u, l] = s.value;
    if (!B(i, l, r))
      return !1;
    a = n.next(), s = o.next();
  }
  return !!(a.done && s.done);
}
function xe(e, t, r) {
  if (e.size !== t.size)
    return !1;
  if (r.has(e))
    return r.get(e) === t;
  r.set(e, t);
  for (const n of e)
    if (!Fe(t, n, r))
      return !1;
  return !0;
}
function Fe(e, t, r) {
  for (const n of e)
    if (B(t, n, r))
      return !0;
  return !1;
}
function Ge(e, t, r) {
  if (e.length !== t.length)
    return !1;
  if (r.has(e))
    return r.get(e) === t;
  r.set(e, t);
  for (let n = 0; n < e.length; n++) {
    const o = Object.hasOwn(e, n), a = Object.hasOwn(t, n);
    if (o !== a || o && !B(e[n], t[n], r))
      return !1;
  }
  return !0;
}
function ze(e, t, r) {
  if (r.has(e))
    return r.get(e) === t;
  r.set(e, t);
  const n = [...Object.keys(e), ...Object.getOwnPropertySymbols(e)], o = [...Object.keys(t), ...Object.getOwnPropertySymbols(t)];
  if (n.length !== o.length)
    return !1;
  for (const a of n)
    if (!(o.includes(a) && B(e[a], t[a], r)))
      return !1;
  return !0;
}
const U = {
  BOOTSTRAP: "Bootstrap",
  TRACKING: "Tracking",
  TRANSLATION: "Translation",
  UTILS: "Utilities"
}, y = {
  LOG: 1,
  WARN: 2,
  ERROR: 3,
  INFO: 4,
  DEFAULT: 5
};
function Ve(e, t) {
  const { B2X_VERSIONS: r = {} } = window || {};
  if (!r[e]) {
    const { buildTime: a, version: s } = t;
    Object.assign(window, {
      B2X_VERSIONS: {
        [e]: `${e}@${s}-${a}`,
        ...r
      }
    });
  }
  const n = be(e);
  return (a, s) => {
    const { args: c = [], level: i = y.LOG, group: u = "Default" } = s || {}, l = new Intl.DateTimeFormat(["pt-PT", "de-DE", "en-GB"], {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(Date.now()), [f, S] = l.split(", "), m = `${f} | ${S} | ${u || ""}
${a}`, M = {
      [y.LOG]: "log",
      [y.WARN]: "warn",
      [y.ERROR]: "error",
      [y.INFO]: "log",
      [y.DEFAULT]: "log"
    }[i] ?? "log", C = n[M] ?? n.log;
    c != null && c.length ? C.call(n, m, ...c) : C.call(n, m);
  };
}
const We = "B2X@SHARED", b = {
  STORE: "store"
}, E = Ve(We, { buildTime: _e, version: Pe });
function qe(e, t) {
  const r = {};
  for (const n in t) {
    const o = t[n];
    typeof o == "function" ? r[n] = (...a) => (Ne(e, n), o(...a)) : E(`Method "${n}" is not a function and was ignored.`, {
      group: U.UTILS,
      level: y.WARN
    });
  }
  return r;
}
function Ut() {
  return window.aemNamespace;
}
const He = "locales", ie = "translations", Je = "localesTimestamp", Ye = 24 * 60 * 60 * 1e3;
let Z, Q;
const Xe = async (e, t) => {
  Z = `${ie}.${e}.${He}`, Q = `${ie}.${e}.${Je}`;
  const r = localStorage.getItem(Z), n = localStorage.getItem(Q);
  if (r && n) {
    const o = new Date(n);
    if ((/* @__PURE__ */ new Date()).getTime() - o.getTime() < Ye)
      return JSON.parse(r);
  }
  return await Ze(e, t);
};
async function Ze(e, t) {
  const r = `${Ie}/${e}/locales?per_page=100`, { data: n, error: o } = await De(
    (async () => (await fetch(r, {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    })).json())()
  );
  if (o || !(n != null && n.length))
    return E(`${t}: Error fetching i18n locales`, {
      args: [o ?? "Locales require to be fetched after a timeout"],
      group: U.TRANSLATION,
      level: o ? y.ERROR : y.INFO
    }), [];
  const a = n.map((s) => s.name);
  return localStorage.setItem(Z, JSON.stringify(a)), localStorage.setItem(Q, (/* @__PURE__ */ new Date()).toISOString()), a;
}
const ce = async (e, t, r) => (await Xe(t, r)).includes(e);
let D;
const Ee = "DE", ve = "en", $ = `${ve}-${Ee}`;
let R = $;
const k = /* @__PURE__ */ new Map();
async function jt(e, t) {
  D = t;
  const { country: r = Ee, language: n = ve } = await Se();
  R = `${n}-${r}`;
  let o = await ce(R, e, D);
  if (!o) {
    if (R = $, o = await ce(R, e, D), !o)
      return E(
        `${D}: Neither ${R} nor the default locale ${$} translations were found. No translations will be loaded.`,
        {
          args: [],
          level: y.INFO,
          group: U.TRANSLATION
        }
      ), k;
    E(
      `${D}: Translations for ${R} were not found, falling back to default locale ${$}.`,
      {
        args: [],
        level: y.INFO,
        group: U.TRANSLATION
      }
    );
  }
  return await le($, e), R === $ || await le(R, e), k;
}
const le = async (e, t) => {
  try {
    k.set(e, {
      locale: e,
      messages: {
        [e]: await Re(e, t, "i18next")
      }
    });
  } catch (r) {
    E(`${D}: Error fetching translations for ${e}.`, {
      args: [r],
      level: y.INFO,
      group: U.TRANSLATION
    });
  }
};
function Kt() {
  const { locale: e, messages: t } = k.get(R) ?? { locale: "unknown", messages: {} }, { locale: r, messages: n } = k.get($) ?? {
    locale: "unknown",
    messages: {}
  }, o = t[e] || {}, a = n[r] || {};
  return {
    exist: (s) => ue(o, a, s) !== s,
    t: (s) => ue(o, a, s),
    availableLocales: [e],
    locale: e
  };
}
function ue(e, t, r) {
  return r.split(".").reduce((n, o) => n == null ? void 0 : n[o], e) || r.split(".").reduce((n, o) => n == null ? void 0 : n[o], t) || r;
}
const Bt = {
  PRIVATE: "profile.context.private.registered",
  COMPANY: "profile.context.company.registered",
  GUEST_PRIVATE: "profile.context.private.guest",
  GUEST_COMPANY: "profile.context.company.guest",
  ADD_COMPANY: "profile.context.company.add",
  NOT_AVAILABLE: "profile.context.not.available",
  NOTIFICATIONS_PROFILES_NOT_AVAILABLE: "profile.context.notifications.profilesNotAvailable",
  PROFILE_NOT_AVAILABLE: "profile.context.not.available"
};
async function xt(e) {
  var S;
  const { packageName: t, event: r, category: n, label: o, action: a, name: s, URL: c = void 0, state: i } = e, u = `${e.type}-${e.version}`, f = {
    event: r,
    eventDetail: {
      category: n,
      action: a,
      label: o,
      URL: c,
      name: s,
      state: i
    },
    application: {
      id: "B2X",
      version: u,
      parentApplicationId: "aem"
    }
  };
  try {
    const m = await Ce(x.TRACKING_CONNECTION_NAME);
    await ((S = m == null ? void 0 : m.pushTrackingEvent) == null ? void 0 : S.call(m, f));
  } catch (m) {
    E(`${t} Analytics track failure`, {
      args: [m],
      level: y.WARN,
      group: U.TRACKING
    });
  }
}
function Ft(e) {
  return new URLSearchParams(window.location.search).get(e);
}
function Qe(e) {
  if (typeof e == "string")
    try {
      return JSON.parse(e);
    } catch {
      return;
    }
}
function fe(e) {
  return {
    get size() {
      return e.length;
    },
    keys() {
      return Array.from({ length: this.size }, (t, r) => e.key(r)).filter(Boolean);
    },
    get(t, r) {
      const n = e.getItem(t);
      if (n === null)
        return r;
      const o = Qe(n);
      return o !== void 0 ? o : typeof r == "string" || r === void 0 && typeof n == "string" ? n : r;
    },
    getAll() {
      return Object.fromEntries(this.keys().map((t) => [t, this.get(t)]));
    },
    set(t, r) {
      e.setItem(t, JSON.stringify(r));
    },
    remove(t) {
      e.removeItem(t);
    },
    clear() {
      e.clear();
    },
    key(t) {
      return e.key(t);
    },
    has(t) {
      return e.getItem(t) !== null;
    }
  };
}
function de(e) {
  return typeof window > "u" ? tt() : window[e];
}
function et() {
  return {
    local: fe(de("localStorage")),
    session: fe(de("sessionStorage"))
  };
}
function tt() {
  const e = /* @__PURE__ */ new Map();
  return {
    get length() {
      return e.size;
    },
    getItem: (t) => e.get(t) ?? null,
    setItem: (t, r) => e.set(t, r),
    removeItem: (t) => e.delete(t),
    clear: () => e.clear(),
    key: (t) => Array.from(e.keys())[t] ?? null
  };
}
const Gt = et(), nt = /* @__PURE__ */ new Set([
  "DE",
  "SE",
  "AT",
  "BE",
  "CH",
  "CZ",
  "DK",
  "SK",
  "ES",
  "FR",
  "HU",
  "IT",
  "LU",
  "NL",
  "PL",
  "PT",
  "RO"
]), rt = /* @__PURE__ */ new Set([
  "SG",
  "AU",
  "ID",
  "IN",
  "JP",
  "KR",
  "MY",
  "NZ",
  "TH",
  "TR",
  "VN",
  "EG",
  "ZA",
  "BR"
]), ot = /* @__PURE__ */ new Set(["US", "CA", "MX"]), V = {
  EU: "EU",
  AP: "AP",
  NA: "NA"
};
function at(e, t) {
  for (const [r, n] of t.entries())
    if (n.has(e))
      return r;
}
const _ = {
  LOCAL: "local",
  DEVELOP: "dev",
  TEST: "test",
  INT: "int",
  PPROD: "pprod",
  PROD: "prod"
}, W = {
  DEV: "https://dev.api.oneweb.mercedes-benz.com",
  INT: "https://int.api.oneweb.mercedes-benz.com",
  PROD: "https://api.oneweb.mercedes-benz.com"
};
function st(e) {
  return Object.values(_).includes(e);
}
function it(e) {
  const t = e.toLowerCase();
  if (!st(t))
    throw new Error(`Invalid stage: "${e}". Expected one of: ${Object.values(_).join(", ")}`);
  return t;
}
async function zt(e, t = []) {
  const r = await Se(), { country: n, stage: o, apiUrl: a } = r, s = it(o), { stageUrls: c, regionCountryMap: i } = ct(e), u = c[s];
  if (t.includes(s))
    return q(u, n, s);
  const l = at(n, i);
  if (l) {
    const f = r[`apiUrl${l}`];
    if (f)
      return q(`${f}/${e}`, n, s);
  }
  if (a)
    return q(`${a}/${e}`, n, s);
  throw new Error(`Unable to resolve service URL for country "${n}" and stage "${o}"`);
}
function q(e, t, r) {
  return { serviceUrl: e, country: t, stage: r };
}
function ct(e) {
  const t = `${W.DEV}/${e}`, r = `${W.INT}/${e}`, n = `${W.PROD}/${e}`, o = {
    [_.LOCAL]: t,
    [_.DEVELOP]: t,
    [_.TEST]: r,
    [_.INT]: r,
    [_.PPROD]: r,
    [_.PROD]: n
  }, a = /* @__PURE__ */ new Map([
    [V.EU, nt],
    [V.AP, rt],
    [V.NA, ot]
  ]);
  return {
    stageUrls: o,
    regionCountryMap: a
  };
}
function h(e, t, r) {
  var o, a, s;
  const n = (o = r == null ? void 0 : r.events) == null ? void 0 : o[e];
  if (typeof n == "function")
    try {
      n(t);
    } catch (c) {
      try {
        (s = (a = r == null ? void 0 : r.events) == null ? void 0 : a.onError) == null || s.call(a, { error: c, context: { type: e, message: "Error in event hook", ...t } });
      } catch (i) {
        E("Error in onError event hook", {
          args: [i],
          group: b.STORE,
          level: y.ERROR
        });
      }
    }
}
function lt({
  options: e,
  prevBaseState: t,
  nextBaseState: r,
  action: n,
  args: o,
  meta: a,
  skipMiddleware: s
}) {
  if (!(e != null && e.middleware) || s)
    return r;
  const c = Array.isArray(e.middleware) ? e.middleware : [e.middleware];
  let i = r;
  for (const u of c)
    try {
      const l = u({ prevState: t, nextState: i, action: n, args: o, meta: a });
      if (l instanceof Promise)
        throw new Error("Async (Promise-returning) middleware is not supported. Middleware must be synchronous.");
      if (l === !1)
        return !1;
      l && typeof l == "object" && (i = l);
    } catch (l) {
      return h("onError", { error: l, action: n, args: o, meta: a }, e), !1;
    }
  return i;
}
function H({ channel: e, baseState: t, shallow: r, sourceId: n }) {
  e == null || e.postMessage({
    type: "setState",
    sourceId: n,
    payload: t,
    shallow: r
  });
}
function ee({
  baseState: e,
  derivedFunctions: t
}) {
  const r = {}, n = {};
  for (const [o, a] of Object.entries(t)) {
    const s = /* @__PURE__ */ new Set(), c = new Proxy(e, {
      get(i, u) {
        if (typeof u == "string") {
          if (u in t)
            throw new Error(
              `Derived function "${String(o)}" attempted to access another derived key "${u}". This is not allowed.`
            );
          if (u in i)
            return s.add(u), i[u];
        }
      }
    });
    try {
      r[o] = a(c), n[o] = s;
    } catch (i) {
      E(`Error computing derived key "${String(o)}":`, {
        args: [i],
        group: b.STORE,
        level: y.ERROR
      });
    }
  }
  return { derivedState: r, derivedDependencies: n };
}
function ut(e, t) {
  const r = {};
  for (const n of Reflect.ownKeys(e)) {
    if (Object.hasOwn(t, n)) {
      E(
        `Attempted to set derived key "${String(n)}" via setState. Derived values are read-only and cannot be set directly.`,
        {
          group: b.STORE,
          level: y.WARN
        }
      );
      continue;
    }
    r[n] = e[n];
  }
  return r;
}
function ft({
  baseState: e,
  derivedFunctions: t,
  update: r,
  shallow: n
}) {
  const o = typeof r == "function" ? r(e) : r, a = ut(o, t);
  return n ? { ...e, ...a } : Oe(e, a);
}
const dt = Object.freeze([
  "getState",
  "setState",
  "subscribe",
  "subscribeTo",
  "resetState",
  "batch",
  "destroy",
  "unsubscribeAll"
]);
function gt(e = {}) {
  return Object.fromEntries(
    Object.entries(e).filter(([t]) => {
      const r = dt.includes(t);
      return r && E(`User-defined API method "${t}" conflicts with core store method and was ignored.`, {
        args: [t],
        group: b.STORE,
        level: y.WARN
      }), !r;
    })
  );
}
function yt(e, t) {
  const r = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set([...Reflect.ownKeys(e), ...Reflect.ownKeys(t)]);
  for (const o of n)
    t[o] !== e[o] && r.add(o);
  return r;
}
function St(e, t) {
  return { ...e, ...t };
}
function ge({
  baseState: e,
  derivedFunctions: t,
  changedKeys: r,
  prevDerivedState: n,
  prevDerivedDependencies: o
}) {
  const a = { ...n }, s = { ...o };
  for (const [c, i] of Object.entries(t)) {
    const u = o[c];
    if (u && [...u].some((l) => r.has(l))) {
      const { derivedState: l, derivedDependencies: f } = ee({
        baseState: e,
        derivedFunctions: { [c]: i }
      }), S = l[c], m = n[c];
      if (Object.is(S, m))
        continue;
      a[c] = l[c], s[c] = f[c];
    }
  }
  return { derivedState: a, derivedDependencies: s };
}
function Ot(e, t) {
  try {
    if (typeof t == "object" && t.enable && t.key)
      return new BroadcastChannel(t.key);
    if (t === !0 && e)
      return new BroadcastChannel(`store-sync:${e}`);
    t === !0 && E(
      'Tab sync requires an "owner" to be defined when no custom key is provided. Set the "owner" option or provide a custom tabSync.key.',
      {
        group: b.STORE,
        level: y.WARN
      }
    );
  } catch (r) {
    E("BroadcastChannel not available or failed to initialize:", {
      args: [r],
      group: b.STORE,
      level: y.WARN
    });
  }
  return null;
}
function mt(e, t) {
  const r = {};
  for (const n in t) {
    const o = t[n];
    typeof o == "function" && (r[n] = (...a) => {
      const s = e.setState, i = { ...e, setState: (u, l = {}) => s.call(e, u, { ...l, action: n, args: a }), ...r };
      return o(i, ...a);
    });
  }
  return r;
}
function Et({
  owner: e,
  enableUsageTracking: t = !1,
  stateCoreMethods: r,
  userDefinedApi: n,
  subscriptionMethods: o,
  untrackedMethods: a = {}
}) {
  const s = new Set(Object.keys(a)), c = mt(r, n);
  if (!e)
    return t && E('Tracking requires an "owner" to be defined. Set the "owner" option to use this feature.', {
      group: b.STORE,
      level: y.WARN
    }), {
      ...r,
      ...o,
      ...c,
      ...a
    };
  const i = Object.fromEntries(
    Object.entries(r).filter(([f]) => !s.has(f))
  ), u = Object.fromEntries(
    Object.entries(o).filter(([f]) => !s.has(f))
  );
  return {
    ...qe(e, {
      ...i,
      ...u,
      ...c
    }),
    ...a
  };
}
function vt({
  channel: e,
  sourceId: t,
  setState: r,
  getBaseState: n,
  tabCounterKey: o,
  isStateBroadcasted: a
}) {
  Number(localStorage.getItem(o)) <= 1 && At(o), e.addEventListener("message", (c) => {
    const { type: i, payload: u, sourceId: l, shallow: f } = c.data || {};
    if (l === t)
      return;
    if (i === "requestState") {
      e.postMessage({ type: "setState", payload: n(), sourceId: t, shallow: !1 });
      return;
    }
    const S = B(u, n());
    if (!(!u || i !== "setState" || S)) {
      a.value = !0;
      try {
        r(() => u, { shallow: f, skipMiddleware: !0 });
      } finally {
        a.value = !1;
      }
    }
  });
}
function At(e) {
  const t = Number(localStorage.getItem(e) ?? "0") + 1;
  return localStorage.setItem(e, String(t)), t;
}
function pt(e) {
  const t = Math.max(0, Number(localStorage.getItem(e) ?? "1") - 1);
  return localStorage.setItem(e, String(t)), t;
}
function ht(e, t, r) {
  for (const n of Reflect.ownKeys(r)) {
    const o = r[n];
    if (!o || o.size === 0)
      continue;
    const a = e[n], s = t[n];
    a !== s && Array.from(o).forEach((c) => {
      try {
        c(a, { prevValue: s, state: e });
      } catch (i) {
        E(`Error in subscriber for key "${String(n)}":`, {
          args: [i],
          group: b.STORE,
          level: y.ERROR
        });
      }
    });
  }
}
function J({
  nextState: e,
  prevState: t,
  subscriptions: r,
  keySubscriptions: n
}) {
  r.forEach((o) => {
    try {
      o(e);
    } catch (a) {
      E("Error in global subscription:", {
        args: [a],
        group: b.STORE,
        level: y.ERROR
      });
    }
  }), ht(e, t, n);
}
function wt(e, t, r) {
  let n = K(e);
  if (r != null && r.persistence) {
    const { key: o, storage: a = localStorage, deserialize: s = JSON.parse } = r.persistence;
    try {
      const c = a.getItem(o);
      c && (n = s(c), t.value = !0);
    } catch (c) {
      h("onError", { error: c, context: { type: "hydrate", state: e } }, r);
    }
  }
  return n;
}
function Y(e, t) {
  if (!(t != null && t.persistence))
    return;
  const { key: r, storage: n = localStorage, serialize: o = JSON.stringify } = t.persistence;
  try {
    const a = o(e);
    n.getItem(r) !== a && n.setItem(r, a);
  } catch (a) {
    h("onError", { error: a, context: { type: "persist", state: e } }, t);
  }
}
function Tt({ channel: e, sourceId: t, isHydrated: r, tabCounterKey: n }) {
  return Number(localStorage.getItem(n)) <= 1 || r.value ? (r.value = !0, Promise.resolve()) : (e.postMessage({ type: "requestState", sourceId: t }), new Promise((a) => {
    const s = (c) => {
      const { type: i } = c.data || {};
      i === "setState" && (r.value = !0, e.removeEventListener("message", s), a());
    };
    e.addEventListener("message", s), setTimeout(() => {
      e.removeEventListener("message", s), r.value = !0, a();
    }, 1e3);
  }));
}
function ye({
  nextBaseState: e,
  changedKeys: t,
  batchDepth: r,
  batchScheduled: n,
  pendingBaseState: o,
  pendingChangedKeys: a
}) {
  return r.value > 0 ? (o.value = e, a.value ? t.forEach((s) => {
    var c;
    return (c = a.value) == null ? void 0 : c.add(s);
  }) : a.value = new Set(t), n.value = !0, !0) : !1;
}
function Vt({ owner: e, initialState: t, derived: r = {}, options: n, api: o }) {
  const a = { value: !1 };
  let s = wt(t, a, n), { derivedState: c, derivedDependencies: i } = ee({ baseState: s, derivedFunctions: r });
  const u = gt(o), l = /* @__PURE__ */ new Set(), f = {}, S = { value: 0 }, m = { value: !1 }, I = { value: null }, M = { value: null }, C = crypto.randomUUID(), A = Ot(e, n == null ? void 0 : n.tabSync), ne = { value: !1 }, G = `${A == null ? void 0 : A.name}_tabCounter`;
  function re(d, {
    shallow: O = (n == null ? void 0 : n.defaultShallow) ?? !1,
    action: g = "setState",
    args: v = [],
    meta: p,
    skipMiddleware: w = !1
  } = {}) {
    const L = N(), Te = { action: g, args: v, meta: p, options: n };
    try {
      let T = ft({
        baseState: S.value > 0 && I.value ? I.value : s,
        derivedFunctions: r,
        update: d,
        shallow: O
      });
      const z = yt(s, T);
      if (z.size === 0 || (T = lt({
        prevBaseState: s,
        nextBaseState: X(T),
        skipMiddleware: w,
        ...Te
      }), T === !1) || ye({ batchDepth: S, batchScheduled: m, pendingBaseState: I, pendingChangedKeys: M, changedKeys: z, nextBaseState: T }))
        return;
      s = T, { derivedState: c, derivedDependencies: i } = ge({
        baseState: s,
        derivedFunctions: r,
        changedKeys: z,
        prevDerivedState: c,
        prevDerivedDependencies: i
      });
      const j = N();
      h("onAction", { action: g, args: v, prevState: L, nextState: j, meta: p }, n), h("onState", { prevState: L, nextState: j, action: g, meta: p }, n), Y(T, n), J({ keySubscriptions: f, subscriptions: l, nextState: j, prevState: L }), ne.value || H({ channel: A, baseState: T, shallow: O, sourceId: C });
    } catch (T) {
      h("onError", { error: T, context: { type: "setState", action: g, args: v, prevState: L, meta: p } }, n);
    }
  }
  function N() {
    let d = St(s, c);
    return (n == null ? void 0 : n.cloneState) !== !1 && (d = K(d)), (n == null ? void 0 : n.freezeState) !== !1 && (d = X(d)), d;
  }
  function Ae() {
    if (ye({
      batchDepth: S,
      batchScheduled: m,
      pendingBaseState: I,
      pendingChangedKeys: M,
      changedKeys: new Set(Object.keys(t)),
      nextBaseState: K(t)
    }))
      return;
    const d = N();
    s = K(t), { derivedState: c, derivedDependencies: i } = ee({ baseState: s, derivedFunctions: r });
    const O = N();
    J({ nextState: O, subscriptions: l, prevState: d, keySubscriptions: f }), H({ channel: A, baseState: s, shallow: !0, sourceId: C }), h("onAction", { action: "resetState", args: [], prevState: d, nextState: O }, n), h("onState", { prevState: d, nextState: O, action: "resetState" }, n), Y(s, n);
  }
  function pe(d, O) {
    let g = d;
    O != null && O.once && (g = (v) => {
      d(v), l.delete(g);
    }), l.add(g);
    try {
      g(N());
    } catch (v) {
      h(
        "onError",
        {
          error: v,
          context: {
            type: "subscribe",
            message: "Error in initial subscriber callback"
          }
        },
        n
      );
    }
    return () => l.delete(g);
  }
  function he(d, O, g) {
    let v = f[d];
    v || (v = /* @__PURE__ */ new Set(), f[d] = v), v.has(O) && E(`Duplicate subscription to key "${String(d)}"`, {
      group: b.STORE,
      level: y.WARN
    });
    let p = O;
    if (g != null && g.once && (p = (w, L) => {
      O(w, L), v.delete(p);
    }), v.add(p), (g == null ? void 0 : g.emitImmediately) !== !1)
      try {
        const w = N();
        p(w[d], { prevValue: void 0, state: w });
      } catch (w) {
        h(
          "onError",
          {
            error: w,
            context: {
              type: "subscribeTo",
              key: d,
              message: `Error in immediate subscription callback for "${String(d)}"`
            }
          },
          n
        );
      }
    return () => {
      var w;
      return (w = f[d]) == null ? void 0 : w.delete(p);
    };
  }
  function oe() {
    l.clear(), Object.entries(f).forEach(([d, O]) => {
      O.clear(), delete f[d];
    });
  }
  async function we() {
    var d;
    A && (vt({
      getBaseState: () => s,
      setState: re,
      channel: A,
      sourceId: C,
      tabCounterKey: G,
      isStateBroadcasted: ne
    }), await Tt({ channel: A, sourceId: C, isHydrated: a, tabCounterKey: G }), (d = window == null ? void 0 : window.addEventListener) == null || d.call(window, "pagehide", se, { once: !0 }));
  }
  function ae(d) {
    if (d.constructor.name === "AsyncFunction")
      throw new Error("Async batch functions are not supported.");
    const O = N();
    S.value++;
    try {
      d();
    } finally {
      if (S.value--, S.value === 0 && m.value) {
        I.value && (s = I.value, { derivedState: c, derivedDependencies: i } = ge({
          baseState: s,
          derivedFunctions: r,
          changedKeys: M.value,
          prevDerivedState: c,
          prevDerivedDependencies: i
        }), I.value = null, M.value = null);
        const g = N();
        h("onAction", { action: "resetState", args: [], prevState: O, nextState: g }, n), h("onState", { prevState: O, nextState: g, action: "resetState" }, n), Y(s, n), J({ nextState: g, subscriptions: l, prevState: O, keySubscriptions: f }), H({ channel: A, baseState: s, shallow: !1, sourceId: C }), m.value = !1;
      }
    }
  }
  function se() {
    oe(), A == null || A.close(), A && pt(G);
  }
  return Et({
    owner: e,
    stateCoreMethods: {
      getState: N,
      setState: re,
      batch: ae,
      resetState: Ae
    },
    userDefinedApi: u,
    subscriptionMethods: {
      subscribe: pe,
      subscribeTo: he,
      unsubscribeAll: oe
    },
    untrackedMethods: {
      batch: ae,
      destroy: se,
      setupTabSync: we
    },
    enableUsageTracking: n == null ? void 0 : n.enableUsageTracking
  });
}
export {
  W as BASE_API_URLS,
  x as CONNECTIONS,
  _t as CROWDIN_PROJECT_BASE_URL,
  U as LOG_GROUPS,
  y as LOG_LEVEL,
  Ie as PHRASE_BASE_URL,
  Bt as PROFILE_CONTEXT_KEYS,
  _ as STAGE,
  _e as buildTime,
  tt as createMemoryStorage,
  Vt as createStore,
  K as deepClone,
  X as deepFreeze,
  Oe as deepMerge,
  B as deeplyEqual,
  xt as dispatchAnalytics,
  Se as getAemConfig,
  Ut as getAemNamespace,
  $t as getComponentRegistryConfig,
  Ce as getConnectionDispatchers,
  Le as getConnectionState,
  Ft as getQueryParameter,
  zt as getServiceRegionConfig,
  Ve as initializeLogger,
  Dt as isLocalhost,
  Me as isObject,
  kt as isPlainObject,
  te as isSeamlessConnectionAvailable,
  st as isStage,
  Mt as isStringified,
  $e as isWindow,
  jt as loadTranslations,
  it as normalizeStage,
  Gt as storage,
  De as tryCatch,
  Kt as useTranslations,
  Pe as version,
  qe as withUsageTracking
};
//# sourceMappingURL=index.mjs.map
